
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';

import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { Link, useNavigate } from 'react-router-dom';

export default function EditButton(props) {
    /*
    const navigate = useNavigate();

    const onClick = () => {
        //props.onClick
        navigate("create", { relative: "path" });
    }
    */

    return (
        <Tooltip title='Edit'>
            {/* <Link to="edit" relative='path' {...props}> */}
                <IconButton
                    component={Link}
                    to="edit"
                    relative='path'
                    size="sm"
                    color="neutral"
                    variant="outlined"
                    sx={{
                        bgcolor: 'background.surface',
                    }}
                    {...props}
                    >
                    <EditRoundedIcon />
                </IconButton>
            {/* </Link> */}
        </Tooltip>
    );
}
